import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const LogoutButtonContainer = styled.div`
  position: fixed;
  top: ${108 * Screen.widthRatio}px;
  left: ${1100 * Screen.widthRatio}px;
`;

export default LogoutButtonContainer;
